import { ScontiStore } from './sconti.store';
import { Observable } from 'rxjs';
import { TableObject } from '../../../models/tableObject';
import { TableService } from '../table.service';
import { Sconti } from '../../../models/sconti';
import { Injectable } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { ScontiGuest } from 'src/app/models/scontiGuest';
import { HttpClient } from '@angular/common/http';
import { ConstantsStore } from '../constants.store';

@Injectable({
  providedIn: 'root'
})
export class ScontiService {
  constructor(
    private store: ScontiStore,
    private tableService: TableService,
    private http: HttpClient,
    private urlsStore: ConstantsStore
  ) { }

  //#region User Area

  get(pageNumber: number = 1, pageSize: number = 10, filter: string = null, ascending: boolean = null): Observable<any> {
    return new Observable<any>(observer => {
      this.httpGet(pageNumber, pageSize, filter, ascending)
        .subscribe(
          (res: TableObject<Sconti>) => {
            this.store.totalRecords = res.totalRecords;
            this.store.load(res.records);
            observer.next(res.records);
          },
          error => observer.error(error)
        );
    });
  }

  sorting(sort: Sort) {
    const data = this.store.records.slice();

    if (!sort.active || sort.direction === '') {
      this.store.sortedRecords = data;
      return;
    }

    this.store.sortedRecords = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Isin': return this.compare(a.isin, b.isin, isAsc);
        case 'Emittente': return this.compare(a.emittente, b.emittente, isAsc);
        case 'Nome': return this.compare(a.nome, b.nome, isAsc);
        case 'Sottostante': return this.compare(a.sottostante, b.sottostante, isAsc);
        case 'Scadenza': return this.compare(a.scadenza, b.scadenza, isAsc);
        case 'Strike': return this.compare(a.strike, b.strike, isAsc);
        case 'Protezione': return this.compare(a.protezione, b.protezione, isAsc);
        case 'Cap': return this.compare(a.cap, b.cap, isAsc);
        case 'Prezzo Sott.': return this.compare(a.prezzosott, b.prezzosott, isAsc);
        case 'Prezzo Cert.': return this.compare(a.prezzocert, b.prezzocert, isAsc);
        case 'Rts': return this.compare(a.rts, b.rts, isAsc);
        case 'Sconto': return this.compare(a.sconto, b.sconto, isAsc);
        default: return 0;
      }
    });
  }

  //#endregion

  //#region Guest Area

  getGuest(): Observable<any> {
    return new Observable<any>(observer => {
      this.httpGetGuest()
        .subscribe(
          (res: ScontiGuest[]) => {
            this.store.loadGuest(res);
            observer.next(res);
          },
          error => observer.error(error)
        );
    });
  }

  sortingGuest(sort: Sort) {
    const data = this.store.recordsGuest.slice();

    if (!sort.active || sort.direction === '') {
      this.store.sortedRecordsGuest = data;
      return;
    }

    this.store.sortedRecordsGuest = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Isin': return this.compare(a.isin, b.isin, isAsc);
        case 'Emittente': return this.compare(a.emittente, b.emittente, isAsc);
        case 'Nome': return this.compare(a.nome, b.nome, isAsc);
        case 'Sottostante': return this.compare(a.sottostante, b.sottostante, isAsc);
        case 'Scadenza': return this.compare(a.scadenza, b.scadenza, isAsc);
        case 'Strike': return this.compare(a.strike, b.strike, isAsc);
        case 'Protezione': return this.compare(a.protezione, b.protezione, isAsc);
        case 'Cap': return this.compare(a.cap, b.cap, isAsc);
        case 'Prezzo Sott.': return this.compare(a.prezzosott, b.prezzosott, isAsc);
        case 'Prezzo Cert.': return this.compare(a.prezzocert, b.prezzocert, isAsc);
        case 'Rts': return this.compare(a.rts, b.rts, isAsc);
        case 'Sconto': return this.compare(a.sconto, b.sconto, isAsc);
        default: return 0;
      }
    });
  }

  //#endregion

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  private httpGet(pageNumber: number, pageSize: number, filter: string, ascending: boolean) {
    const scontiUrl = `${this.urlsStore.scontiUrl}/${pageNumber}/${pageSize}${this.urlsStore.filterAndAscendingQueryString(filter, ascending)}`;
    return this.http.get<TableObject<Sconti>>(scontiUrl);
  }

  private httpGetGuest() {
    return this.http.get<ScontiGuest[]>(this.urlsStore.scontiUrl);
  }
}
